__turbopack_context__.v({
  "addressCell": "PropertiesTable-module__K7FXNq__addressCell",
  "addressText": "PropertiesTable-module__K7FXNq__addressText",
  "cellText": "PropertiesTable-module__K7FXNq__cellText",
  "externalLinkIcon": "PropertiesTable-module__K7FXNq__externalLinkIcon",
  "linkCell": "PropertiesTable-module__K7FXNq__linkCell",
  "linkCellText": "PropertiesTable-module__K7FXNq__linkCellText",
  "parcelActions": "PropertiesTable-module__K7FXNq__parcelActions",
  "parcelButton": "PropertiesTable-module__K7FXNq__parcelButton",
  "propertyIdCell": "PropertiesTable-module__K7FXNq__propertyIdCell",
  "propertyIdIcon": "PropertiesTable-module__K7FXNq__propertyIdIcon",
  "propertyIdText": "PropertiesTable-module__K7FXNq__propertyIdText",
  "tableContainer": "PropertiesTable-module__K7FXNq__tableContainer",
  "zillowLink": "PropertiesTable-module__K7FXNq__zillowLink",
});
